/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useEffect, useState } from "react";
import Media from "../../elements/Media";
import OverlaySpinner from "../../elements/OverlaySpinner";
import debug from "../../util/constants/Debug";

const CaptivePortalSplashScreen = ({
  url,
  fadeInTime = "250",
  displayTime = "5000",
  fadeOutTime = "750",
  onFadeIn,
  onFadeOut,
  onCompletion,
  onError
}) => {
  // state: [ loading, fadeIn, display, fadeOut, complete, error ]
  const [state, setState] = useState(url == null ? "complete" : "loading");

  // handlers
  useEffect(() => {
    let timer = null;

    // action based on state
    switch (state) {
      case "fadeIn":
        timer = setTimeout(() => {
          setState("display");
        }, fadeInTime);
        break;
      case "display":
        onFadeIn?.();
        timer = setTimeout(() => {
          setState("fadeOut");
        }, displayTime);
        break;
      case "fadeOut":
        onFadeOut?.();
        timer = setTimeout(() => {
          setState("complete");
        }, fadeOutTime);
        break;
      case "complete":
        onCompletion?.();
        break;
      case "error":
        debug.log("Error");
        onError?.();
        break;
      default: return;
    }

    // return clear timer handle for useEffect
    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // if done, return null
  if (state === "complete") {
    return null;
  }

  // css transition based on state
  let opacity = "0";
  let transitionTime = "0";

  switch (state) {
    case "fadeIn":
      opacity = "100";
      transitionTime = fadeInTime;
      break;
    case "display":
      opacity = "100";
      break;
    case "fadeOut":
      transitionTime = fadeOutTime;
      break;
    default: break;
  }

  const containerStyle = {
    objectFit: "contain",
    opacity: opacity,
    transition: `all ${transitionTime}ms ease-in`,
  };

  const mediaStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    position: "absolute"
  };

  if (state === "complete" || state === "error") {
    return null;
  }

  return (
    <>
      <div className="splash-screen-layer" style={containerStyle}>
        <Media
          src={url}
          onLoad={() => setState("fadeIn")}
          onError={() => setState("error")}
          style={mediaStyle}
        />
      </div>
      <OverlaySpinner show={state === "loading"} />
    </>
  );
};

export default CaptivePortalSplashScreen;
